import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import api from '../../services/api';

function InviteMemberModal({ onClose, onInvited }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    setError('');
    try {
      await api.post('/family/members/invite', { email: email.trim() });
      setSuccess(true);
      onInvited && onInvited(email.trim());
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send invitation. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '420px' }}>
        <div className="modal-header">
          <h3>Invite Family Member</h3>
          <button onClick={onClose}>&#10005;</button>
        </div>
        <div style={{ padding: '1.5rem' }}>
          {success ? (
            <div style={{ textAlign: 'center' }}>
              <p style={{ marginBottom: '1rem' }}>Invitation sent to <strong>{email}</strong>!</p>
              <p style={{ fontSize: '0.875em', opacity: 0.8, marginBottom: '1.25rem' }}>
                They'll receive an email with a link to join your family group.
                The invitation expires in 7 days.
              </p>
              <button className="btn-save" onClick={onClose}>Done</button>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <p style={{ fontSize: '0.875em', opacity: 0.8, marginBottom: '1rem' }}>
                Enter the email address of the person you'd like to invite.
                They'll create their own account and join your family.
              </p>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Email address"
                required
                autoFocus
                style={{
                  width: '100%', padding: '0.5rem', borderRadius: '4px',
                  border: '1px solid #ddd', marginBottom: '1rem', boxSizing: 'border-box',
                }}
              />
              {error && <p style={{ color: 'red', fontSize: '0.875em', marginBottom: '0.75rem' }}>{error}</p>}
              <div style={{ display: 'flex', gap: '0.75rem' }}>
                <button type="button" onClick={onClose} style={{ flex: 1, padding: '0.5rem', border: '1px solid #ddd', borderRadius: '6px', background: 'none', cursor: 'pointer' }}>
                  Cancel
                </button>
                <button type="submit" className="btn-save" disabled={loading} style={{ flex: 1 }}>
                  {loading ? 'Sending…' : 'Send Invitation'}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}

export default InviteMemberModal;
